import React from 'react';

const SvgPrices = props => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path
      d="M18.65 16.43a.81.81 0 00-.84-.77.86.86 0 00-.71.38 4.18 4.18 0 01-3.55 2.21c-2 0-3.61-1.41-4.32-3.7h5.1a.86.86 0 00.85-.86.85.85 0 00-.85-.85H8.9v-.86a8.26 8.26 0 01.06-1h5.4a.86.86 0 00.85-.86.85.85 0 00-.85-.85h-5c.72-2.15 2.26-3.52 4-3.52A4.3 4.3 0 0117 7.85a.89.89 0 00.73.39.86.86 0 00.85-.86.91.91 0 00-.19-.54 5.92 5.92 0 00-5.09-2.75c-2.7 0-5 2-5.87 5.18H6.2a.85.85 0 100 1.7h.94V12.79H6.2a.86.86 0 100 1.71h1.2c.81 3.27 3.17 5.36 6.09 5.36 2 0 3.59-.93 5-2.94a1 1 0 00.17-.5z"
      fill="#989898"
    />
  </svg>
);

export default SvgPrices;
